import { Component, Input } from "@angular/core";

@Component({
  selector: "common-things-to-know-section",
  templateUrl: "./things-to-know-section.component.html",
  styleUrls: ["./things-to-know-section.component.scss"],
})
export class ThingsToKnowSectionComponent {
  @Input() buyItNowOnly: boolean = false; // Default value is false

  marketingCards = [
    {
      iconClass: "icon-transportation",
      title: "Transportation",
      body:
        "Rubbl supports both short and long hauls across state lines. Transportation is not included in your rental rate. Once an order is placed you will receive a quote within 1 business day.",
    },
    {
      iconClass: "icon-time",
      title: "Usage Limit",
      body: "Equipment can be used for 160 hours per month throughout the length of the rental. Total usage is calculated cumulatively over the entire rental.",
    },
    {
      iconClass: "icon-overages",
      title: "Overages",
      body: "Any hours used over the 160-hour cumulative monthly limit will be charged at the end of the rental and will appear on your final statement.",
    },
    {
      iconClass: "icon-stepper-add",
      title: "Extensions",
      body: "You are free to extend a rental as needed.",
    },
    {
      iconClass: "icon-cancel",
      title: "Cancellation",
      body:
        "To receive a full refund, cancellations must be made at least 24 hours before the first machine in the order is picked up. Charges may apply for cancellations made after this period.",
    },
  ];

  get filteredMarketingCards() {
    // Filter out "Usage Limit" and "Overages" if it's Buy It Now only
    if (this.buyItNowOnly) {
      return this.marketingCards.filter(
        (card) => card.title !== "Usage Limit" && card.title !== "Overages" && card.title !== "Extensions"
      );
    }
    return this.marketingCards;
  }
}
